import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 78232953-CC68-48A1-A4A5-DC64B46216BC
 * name arrow-u-right-top
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-u-right-top.svg
 * tags
 */
export const ArrowURightTopIcon = createSvgIcon(<><path d="M10.5 18H18V20H10.5C6.91 20 4 17.09 4 13.5S6.91 7 10.5 7H16.17L13.08 3.91L14.5 2.5L20 8L14.5 13.5L13.09 12.09L16.17 9H10.5C8 9 6 11 6 13.5S8 18 10.5 18Z" /></>, 'ArrowURightTopIcon');
export default ArrowURightTopIcon